import CallButton from "components/CallButton";

export default function HelpFooter() {
  return (
    <div className="bg-oat px-4 pb-20 pt-6 text-center sm:py-6">
      <p className="mb-3 text-sm text-evergreen">
        Need help? Our care team is available to assist you.
      </p>
      <div className="mx-auto max-w-xs">
        <CallButton variant="compact" />
      </div>
    </div>
  );
}
